export default function (server, type, roles) {
  for (let role of roles) {
    server.create(type, {
      ...role,
    });
  }
}
